import cookies from 'js-cookie';

const APP_BANNER_COOKIE_NAME = 'ha-app-banner';

function createCookie() {
    const days = 7;
    cookies.set(APP_BANNER_COOKIE_NAME, 0, {expires: days});
}

function cookieExists(cookieName) {
    let cookieValue = cookies.get(cookieName);
    if (typeof cookieValue !== 'undefined') {
        return true;
    }
    return false;
}

export {
    APP_BANNER_COOKIE_NAME,
    createCookie,
    cookieExists
};